import React from "react";
import PageHero from "../components/PageHero";
import { DEPARTMENTS } from "../data/site";

export default function Departments() {
  return (
    <div data-testid="departments-page">
      <PageHero
        eyebrow="Departments"
        title={<>Specialists for every <span className="italic text-brand-maroon">stage of life.</span></>}
        subtitle="Daily OPDs across General Medicine, Gynecology, Pediatrics, Surgery, Orthopedics and Dermatology."
        image="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1400&q=85"
      />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20 space-y-6">
        {DEPARTMENTS.map((d, i) => (
          <article
            key={d.key}
            data-testid={`dept-row-${d.key}`}
            className={`grid md:grid-cols-12 gap-8 items-center rounded-3xl bg-white border border-brand-beige overflow-hidden ${
              i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
            }`}
          >
            <div className="md:col-span-5 aspect-[5/4] overflow-hidden">
              <img
                src={d.image}
                alt={d.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="md:col-span-7 p-8 md:p-12">
              <div className="text-xs uppercase tracking-[0.22em] font-bold text-brand-maroon">
                Department
              </div>
              <h2 className="font-serif-display text-3xl md:text-4xl text-brand-ink mt-2">{d.name}</h2>
              <p className="mt-4 text-brand-ink/70 leading-relaxed">{d.description}</p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["OPD", "IPD", "Day-care", "Insurance"].map((tag) => (
                  <span
                    key={tag}
                    className="text-[11px] uppercase tracking-[0.18em] font-semibold text-brand-ink/55 border border-brand-ink/15 rounded-full px-3 py-1"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
